module.exports = __webpack_public_path__ + "media/images/fotos/fruteria-5b0c775ab79916d9e0aa84dfddd18c61.jpg";